import {
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowBackIos, Mail, Save, Search } from '@material-ui/icons'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import vistoriaService from '../Services/Vistoria/vistoria-service'
import veiculoService from '../Services/Veiculo/veiculo-service'
import { Alert } from '@material-ui/lab'
import { Box } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import html2pdf from 'html2pdf.js'
import CustomAlert from '../components/alert/CustomAlert'
import BlueButton from '../components/button/BlueButton'
import { statusVistoria } from '../util/statusVistoria'
import { validateVistoria } from '../util/validateVistoria'
import { AvlLatariaVistoria } from './components/vistoria/avl-lataria-vistoria-component'
import { AvlPreliminarVistoria } from './components/vistoria/avl-preliminar-vistoria-component'
import { EmailModal } from './components/vistoria/email-modal-component'
import { ListaProdutosServicos } from './components/vistoria/lista-produtos-component'
import { VistoriaItems } from './components/vistoria/vistoria-items-component'

const useStyles = makeStyles((theme) => ({
  actions: {
    marginBottom: 6,
    float: 'left'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 20px 60px',
    borderRadius: 10,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px'
    }
  },
  title: {
    fontSize: 23,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 50
  },
  subtitle: {
    fontSize: 19,
    fontWeight: 'bold',
    marginTop: 40,
    marginBottom: 20
  },
  radioP: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  radioTitle: {
    fontSize: 16,
    marginRight: 10
  },
  itemText: {
    fontSize: 18
  },
  errorText: {
    color: '#FF0000'
  },
  tituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#209BDE',
    fontSize: '22px',
    textAlign: 'start',
    padding: '0 0px',
    marginBottom: '5px'
  },
  mensagemStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#209BDE',
    fontSize: '22px',
    textAlign: 'start',
    padding: '0 0px'
  },
  subtituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#7F7F7F',
    fontSize: '16px',
    fontWeight: 'inherit',
    textAlign: 'start',
    padding: '0 0px',
    marginTop: '0px'
  },
  linkStyle: { color: '#209BDE', textDecoration: 'underline' }
}))

const AUTO_ITEM_CODIGO = 'S000.1222.00'
const AUTO_ITEM_NOME = 'SERVICO INSTALACAO TELEMETRIA RI64XX'

export function OSVistoriaPage({
  ordemServico,
  handleBack,
  tipoVistoria,
  itensOS,

  estoqueItens = [],
  addProduto,
  consultaDetalheOS,
  consultaProdutosEstoque,

  setMensagemAlert: setMensagemAlertPai,
  setTipoAlert: setTipoAlertPai,
  setAbrirAlert: setAbrirAlertPai
}) {
  const classes = useStyles()
  const [vistoria, setVistoria] = useState(null)
  const [editVistoria, setEditVistoria] = useState(false)
  const [disabledEditEntry, setDisabledEditEntry] = useState(false)
  const [disabledEditExit, setDisabledEditExit] = useState(false)
  const [loadSave, setLoadSave] = useState(false)
  const [loadVistoria, setLoadVistoria] = useState(false)
  const [openEmailModal, setOpenEmailModal] = useState(false)
  const [errors, setErrors] = useState({})
  const [alertEmailEnviado, setAlertEmailEnviado] = useState(false)
  const [mensagemAlertaEmail, setMensagemAlertaEmail] = useState('')
  const inputVistoriaRef = useRef(null)
  const [abrirAlert, setAbrirAlert] = useState(false)
  const [mensagemAlert, setMensagemAlert] = useState('')
  const [tipoAlert, setTipoAlert] = useState('error')
  const locais = ['Volante', 'Ponto fixo']

  const onlyDigits = (v = '') => (v || '').replace(/\D/g, '')
  const [cpfError, setCpfError] = useState('')

  const isLeavingRef = useRef(false)

  const [placaLoading, setPlacaLoading] = useState(false)
  const [placaErro, setPlacaErro] = useState('')
  const [permiteEdicaoManualPlaca, setPermiteEdicaoManualPlaca] = useState(false)
  const placaTimerRef = useRef(null)

  const autoLockRef = useRef(false)
  const lastAnoAppliedRef = useRef(null)

  const [autoItemUI, setAutoItemUI] = useState({
    visible: false,
    severity: 'info',
    message: '',
    ano: null
  })

  const [itensOSLocal, setItensOSLocal] = useState(Array.isArray(itensOS) ? itensOS : [])
  const itensOSRef = useRef(Array.isArray(itensOS) ? itensOS : [])

  useEffect(() => {
    const list = Array.isArray(itensOS) ? itensOS : []
    setItensOSLocal(list)
    itensOSRef.current = list
  }, [itensOS])

  useEffect(() => {
    return () => {
      isLeavingRef.current = true
      if (placaTimerRef.current) clearTimeout(placaTimerRef.current)
    }
  }, [])

const showAlert = (payload, type = 'info') => {
  if (isLeavingRef.current) return

  setMensagemAlert(payload)
  setTipoAlert(type)
  setAbrirAlert(true)

  if (setMensagemAlertPai && setTipoAlertPai && setAbrirAlertPai) {
    setMensagemAlertPai(payload)
    setTipoAlertPai(type)
    setAbrirAlertPai(true)
  }
}

  const normalizarTexto = (value = '') => {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase()
  }

  const isInstalacao = () => normalizarTexto(ordemServico?.tipoServicoAgendamento).includes('INSTALACAO')
  const precisaValidarPlaca = () => !isInstalacao()

  const shouldDisableAutoFetch = false

  const isValidCPF = (cpf) => {
    cpf = onlyDigits(cpf)
    if (cpf.length !== 11) return false
    if (/^(\d)\1+$/.test(cpf)) return false

    let soma = 0
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
    let resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cpf.charAt(9))) return false

    soma = 0
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
    resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cpf.charAt(10))) return false

    return true
  }

  const handleCpfBlur = () => {
    const cpf = vistoria?.clienteCpfCnpj
    if (!cpf) {
      setCpfError('Informe o CPF')
      return
    }

    if (!isValidCPF(cpf)) setCpfError('CPF inválido')
    else setCpfError('')
  }

  const isCpfInvalid = () => {
    const v = vistoria?.clienteCpfCnpj
    if (!v) return true
    return !isValidCPF(v)
  }

  const isAceito = statusVistoria(vistoria, tipoVistoria) === 'Aceito'
  const isDisabledEntry = disabledEditEntry || isAceito

  const handleInputChange = (atr, value) => {
    setVistoria((checkList) => ({
      ...(checkList || {}),
      [atr]: value
    }))
  }

  const buscarAnoCorPorPlaca = async (placaDigitada) => {
    if (isLeavingRef.current) return

    const p = (placaDigitada || '').toUpperCase().trim()
    const pLimpa = p.replace(/[^A-Z0-9]/g, '')

    if (pLimpa.length < 7) {
      setPlacaErro('')
      return
    }

    setPlacaLoading(true)
    setPlacaErro('')

    try {
      const resp = await veiculoService.consultarDadosCadastrais(pLimpa)

      if (resp?.error) {
        setPlacaErro(resp?.message || 'Não foi possível consultar a placa. Preencha ano e cor manualmente.')
        handleInputChange('ano', '')
        handleInputChange('cor', '')
        setPermiteEdicaoManualPlaca(true)
        return
      }

      const anoModelo = resp?.anoModelo ?? ''
      const cor = resp?.cor ?? ''

      handleInputChange('ano', anoModelo || '')
      handleInputChange('cor', cor || '')

      if (!anoModelo || !cor) {
        setPlacaErro('Consulta não retornou ano/cor. Preencha manualmente.')
        setPermiteEdicaoManualPlaca(true)
      } else {
        setPlacaErro('')
        setPermiteEdicaoManualPlaca(false)
      }
    } catch (e) {
      setPlacaErro('Falha ao consultar a placa. Preencha manualmente.')
      handleInputChange('ano', '')
      handleInputChange('cor', '')
      setPermiteEdicaoManualPlaca(true)
    } finally {
      setPlacaLoading(false)
    }
  }

  const handlePlacaChange = (event) => {
    const raw = event.target.value || ''
    const formatted = raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7)

    handleInputChange('placa', formatted)
    handleInputChange('ano', '')
    handleInputChange('cor', '')
    setPermiteEdicaoManualPlaca(false)

    setPlacaErro('')
    setAutoItemUI({
      visible: false,
      severity: 'info',
      message: '',
      ano: null
    })

    lastAnoAppliedRef.current = null

    if (placaTimerRef.current) clearTimeout(placaTimerRef.current)

    if (formatted.length === 7 && statusVistoria(vistoria, tipoVistoria) !== 'Aceito') {
      placaTimerRef.current = setTimeout(() => {
        buscarAnoCorPorPlaca(formatted)
      }, 600)
    }
  }
  const handlePlacaSearchClick = async () => {
    if (statusVistoria(vistoria, tipoVistoria) === 'Aceito') return

    const pl = String(vistoria?.placa || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 7)

    if (pl.length < 7) {
      setPlacaErro('Placa incompleta')
      return
    }

    await buscarAnoCorPorPlaca(pl)
  }

  const placaHelper = useMemo(() => {
    if (!precisaValidarPlaca()) return 'Digite a Placa para instalação'
    if (errors.placa?.message) return errors.placa?.message
    if (placaErro) return placaErro
    return 'Digite a placa e clique na lupa (ou aguarde) para buscar ano e cor'
  }, [errors.placa?.message, placaErro, ordemServico?.tipoServicoAgendamento])

  const normalizeCode = (v = '') => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '')

  const estoqueRef = useRef([])
  useEffect(() => {
    estoqueRef.current = Array.isArray(estoqueItens) ? estoqueItens : []
  }, [estoqueItens])

  const getCodigoEstoque = (e) =>
    String(
      e?.codProduto ??
        e?.CodProduto ??
        e?.produtoNumero ??
        e?.numeroProduto ??
        e?.codigo ??
        e?.codigoProduto ??
        e?.produtoCodigo ??
        e?.numero ??
        e?.sku ??
        e?.id ??
        ''
    ).trim()

  const getCodigoItemOS = (i) =>
    String(
      i?.codProduto ??
        i?.CodProduto ??
        i?.numeroProduto ??
        i?.produtoNumero ??
        i?.codigo ??
        i?.codigoProduto ??
        i?.produtoCodigo ??
        i?.numero ??
        i?.sku ??
        i?.produtoNumeroOS ??
        i?.produto ??
        ''
    ).trim()

  const getProdutoIdSeguro = (p) =>
    p?.produtoId ??
    p?.id ??
    p?.idProduto ??
    p?.produtoID ??
    p?.ProdutoId ??
    p?.ProdutoID ??
    p?.tz_ItemId ??
    null

  const getProdutoIdItemOS = (i) =>
    i?.produtoId ??
    i?.idProduto ??
    i?.ProdutoId ??
    i?.ProdutoID ??
    i?.tz_ItemId ??
    i?.tzItemId ??
    null

  const findItemInListByCodigo = (list, codigo) => {
    const alvo = normalizeCode(codigo)
    const lista = Array.isArray(list) ? list : []
    return (
      lista.find((i) => {
        const code = normalizeCode(getCodigoItemOS(i))
        const alt = normalizeCode(
          i?.codProduto || i?.CodProduto || i?.codigoProduto || i?.produtoCodigo || i?.produtoNumero || i?.numero || ''
        )
        return code === alvo || alt === alvo
      }) || null
    )
  }

  const findItemInListByProdutoId = (list, produtoId) => {
    const alvo = String(produtoId || '').trim()
    if (!alvo) return null
    const lista = Array.isArray(list) ? list : []
    return lista.find((i) => String(getProdutoIdItemOS(i) || '').trim() === alvo) || null
  }

  const findItemInOSByCodigo = (codigo) => findItemInListByCodigo(itensOSRef.current, codigo)
  const findItemInOSByProdutoId = (produtoId) => findItemInListByProdutoId(itensOSRef.current, produtoId)

  const findProdutoNoEstoquePorCodigo = (codigo) => {
    const lista = Array.isArray(estoqueRef.current) ? estoqueRef.current : []
    if (!lista.length) return null

    const alvo = normalizeCode(codigo)

    let found = lista.find((e) => normalizeCode(getCodigoEstoque(e)) === alvo)
    if (found) return found

    const nomeAlvo = String(AUTO_ITEM_NOME || '').toUpperCase().trim()
    found = lista.find((e) => String(e?.nome || '').toUpperCase().trim() === nomeAlvo)
    if (found) return found

    found = lista.find((e) => {
      const n = String(e?.nome || '').toUpperCase()
      return n.includes('SERVICO') && n.includes('INSTALACAO') && n.includes('TELEMETRIA')
    })
    return found || null
  }

  const refreshItensOS = async () => {
    if (typeof consultaDetalheOS !== 'function') return itensOSRef.current || []

    try {
      const resp = await consultaDetalheOS()

      const list =
        (Array.isArray(resp) && resp) ||
        (Array.isArray(resp?.data) && resp.data) ||
        (Array.isArray(resp?.data?.itens) && resp.data.itens) ||
        (Array.isArray(resp?.itens) && resp.itens) ||
        (Array.isArray(resp?.items) && resp.items) ||
        []

      setItensOSLocal(list)
      itensOSRef.current = list
      return list
    } catch (e) {
      return itensOSRef.current || []
    }
  }

  const garantirEstoqueCarregado = async () => {
    if (Array.isArray(estoqueRef.current) && estoqueRef.current.length > 0) return true
    if (typeof consultaProdutosEstoque !== 'function') return false

    try {
      await consultaProdutosEstoque()
      await new Promise((r) => setTimeout(r, 0))
      return Array.isArray(estoqueRef.current) && estoqueRef.current.length > 0
    } catch (e) {
      return false
    }
  }

  const extractBackendErrorMessage = (e) => {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.erro ||
      e?.response?.data?.error ||
      e?.message ||
      'Falha inesperada.'
    return String(msg)
  }

  const aplicarRegraAnoAutoItem = async (anoValue) => {
    if (isLeavingRef.current) return
    if (isInstalacao()) return

    if (typeof addProduto !== 'function') return

    const anoNum = Number(anoValue || 0)
    if (!anoNum) return
    if (autoLockRef.current) return

    if (lastAnoAppliedRef.current === anoNum) return
    lastAnoAppliedRef.current = anoNum

    const precisaTelemetria = anoNum > 2012

    if (!precisaTelemetria) {
      setAutoItemUI({
        visible: true,
        severity: 'info',
        ano: anoNum,
        message: `Ano ${anoNum} não requer telemetria.`
      })
      return
    }

    const okEstoque = await garantirEstoqueCarregado()
    if (!okEstoque) {
      showAlert(
        { title: 'Atenção!', body: 'Não foi possível carregar o estoque para aplicar a regra automática.' },
        'fail'
      )
      return
    }

    const prod = findProdutoNoEstoquePorCodigo(AUTO_ITEM_CODIGO)
    const produtoId = prod ? getProdutoIdSeguro(prod) : null

    const existePorCodigo = !!findItemInOSByCodigo(AUTO_ITEM_CODIGO)
    const existePorId = !!findItemInOSByProdutoId(produtoId)

    setAutoItemUI({
      visible: true,
      severity: 'warning',
      ano: anoNum,
      message: `Atenção: Ano ${anoNum} requer o serviço de telemetria (${AUTO_ITEM_CODIGO}).`
    })

    if (existePorCodigo || existePorId) {
      setAutoItemUI((s) => ({
        ...s,
        severity: 'success',
        message: `Ano ${anoNum} detectado. Serviço de telemetria já está em "Produtos e Serviços".`
      }))
      return
    }

    if (!prod) {
      setAutoItemUI((s) => ({
        ...s,
        severity: 'error',
        message: `Não encontrei o item correto "${AUTO_ITEM_CODIGO}" no estoque.`
      }))
      showAlert(
        { title: 'Atenção!', body: `Não encontrei o item correto "${AUTO_ITEM_CODIGO}" no estoque.` },
        'fail'
      )
      return
    }

    if (!produtoId) {
      setAutoItemUI((s) => ({
        ...s,
        severity: 'error',
        message: `Item "${AUTO_ITEM_CODIGO}" encontrado, mas sem ID válido.`
      }))
      showAlert(
        { title: 'Atenção!', body: `Item "${AUTO_ITEM_CODIGO}" encontrado, mas sem ID válido.` },
        'fail'
      )
      return
    }

    autoLockRef.current = true
    try {
      await addProduto(
        String(produtoId).trim(),
        prod.nome || AUTO_ITEM_NOME,
        1,
        AUTO_ITEM_CODIGO,
        true,
        false,
        false,
        null,
        null,
        null
      )

      setAutoItemUI((s) => ({
        ...s,
        severity: 'success',
        message: `Ano ${anoNum} detectado. Serviço de telemetria enviado para inclusão.`
      }))

      setTimeout(() => {
        refreshItensOS()
      }, 800)
    } catch (e) {
      const msg = extractBackendErrorMessage(e)
      setAutoItemUI((s) => ({
        ...s,
        severity: 'error',
        message: `Falha ao adicionar automaticamente "${AUTO_ITEM_CODIGO}". (${msg})`
      }))
      showAlert(
        { title: 'Erro!', body: `Falha ao adicionar automaticamente "${AUTO_ITEM_CODIGO}".\n\nDetalhe: ${msg}` },
        'error'
      )
    } finally {
      autoLockRef.current = false
    }
  }

  useEffect(() => {
    if (isLeavingRef.current) return
    if (isInstalacao()) return
    const ano = Number(vistoria?.ano || 0)
    if (!ano) return
    aplicarRegraAnoAutoItem(ano)
  }, [vistoria?.ano, shouldDisableAutoFetch, ordemServico?.tipoServicoAgendamento])

  useEffect(() => {
    if (!ordemServico) return

    getVistoria()

    handleInputChange('equipamento', ordemServico?.rastreador)
    handleInputChange('serie', ordemServico?.num_serie_contrato)
    handleInputChange('tipo_servico', ordemServico?.tipoServico)
    handleInputChange('local_servico', ordemServico?.localAtendimento)

    const pl = String(ordemServico?.placa || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 7)

    handleInputChange('placa', pl)

    handleInputChange('cor', ordemServico?.cor || '')
    handleInputChange('ano', ordemServico?.ano || null)

    if (pl && statusVistoria(vistoria, tipoVistoria) !== 'Aceito' && (!ordemServico?.ano || !ordemServico?.cor)) {
      setTimeout(() => buscarAnoCorPorPlaca(pl), 0)
    }
  }, [ordemServico, shouldDisableAutoFetch])

  async function getVistoria() {
    try {
      setLoadVistoria(true)
      const { osID, activityId } = ordemServico

      const responseVistoria = await vistoriaService.consultaVistoria(activityId, osID)
      if (responseVistoria?.error) {
        showAlert({ title: 'Erro!', body: responseVistoria?.message }, 'error')
      } else {
        if (responseVistoria) {
          setVistoria(responseVistoria)
          setMensagemAlertaEmail(obterMensagemAlertaEmail(responseVistoria))
          setEditVistoria(true)

          if (responseVistoria.entrada) setDisabledEditEntry(true)
          if (responseVistoria.saida) setDisabledEditExit(true)

          const pl = String(responseVistoria?.placa || '')
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 7)

          if (pl && statusVistoria(responseVistoria, tipoVistoria) !== 'Aceito' && (!responseVistoria?.ano || !responseVistoria?.cor)) {
            setTimeout(() => buscarAnoCorPorPlaca(pl), 0)
          }
        } else {
          setEditVistoria(false)
        }
      }
    } catch (error) {
      console.log(error?.toString?.() || error)
    } finally {
      setLoadVistoria(false)
    }
  }

  const cpfChange = (event) => {
    let cpf = event.target.value
    cpf = cpf.replace(/\D/g, '')
    cpf = cpf.slice(0, 11)

    let cpfFormatado = ''
    for (let i = 0; i < cpf.length; i++) {
      if (i === 3 || i === 6) cpfFormatado += '.'
      else if (i === 9) cpfFormatado += '-'
      cpfFormatado += cpf[i]
    }

    handleInputChange('clienteCpfCnpj', cpfFormatado)
  }

  const obterMensagemAlertaEmail = (vistoriaLocal) => {
    const tipoVistoriaLocal = vistoriaLocal.checkListTipo

    const formatarData = (data) => {
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }
      const dataFormatada = new Date(data).toLocaleString('pt-BR', options)
      return `${dataFormatada.substr(0, 10)} às ${dataFormatada.substr(12)}.`
    }

    if (vistoriaLocal && (vistoriaLocal.dataEnvioEmailDeSaida || vistoriaLocal.dataEnvioEmailDeEntrada)) {
      if (vistoriaLocal.dataEnvioEmailDeSaida && tipoVistoriaLocal === 'Saida') {
        setAlertEmailEnviado(true)
        return `E-mail de vistoria de saída enviado em ${formatarData(vistoriaLocal.dataEnvioEmailDeSaida)}`
      } else if (vistoriaLocal.dataEnvioEmailDeEntrada && tipoVistoriaLocal === 'Entrada') {
        setAlertEmailEnviado(true)
        return `E-mail de vistoria de entrada enviado em ${formatarData(vistoriaLocal.dataEnvioEmailDeEntrada)}`
      }
    }

    return null
  }

  const parseBool = (value) => (value === 'true' || value === true ? true : false)

  const handleSaveVistoria = async () => {
    const validate = validateVistoria(vistoria)

    if (!vistoria?.clienteCpfCnpj) {
      validate.clienteCpfCnpj = { message: 'Informe o CPF do conferente' }
      setCpfError('Informe o CPF')
    } else if (isCpfInvalid()) {
      validate.clienteCpfCnpj = { message: 'CPF do conferente inválido' }
      setCpfError('CPF inválido')
    }

    if (Object.keys(validate).length !== 0) {
      setErrors(validate)

      const campos = Object.values(validate)
        .map((e) => e?.message)
        .filter(Boolean)

      const camposResumo = campos.slice(0, 3)
      const restante = campos.length - camposResumo.length

      showAlert(
        {
          title: 'Atenção!',
          body:
            `Corrija os campos obrigatórios destacados em vermelho:\n\n` +
            camposResumo.join('\n') +
            (restante > 0 ? `\n\nE mais ${restante} campo(s) obrigatório(s).` : '')
        },
        'fail'
      )

      return
    }

    setCpfError('')

    const resultSave = await saveVistoria()

    if (!resultSave.success) {
      return
    }

    const dados = {
      AtividadeId: ordemServico?.activityId,
      TipoVistoria: vistoria.checkListTipo,
      ImagemBase64: vistoria.vistoriaPdfBase64
    }

    await vistoriaService.enviaPDFVistoria(JSON.stringify(dados))

    showAlert({ title: 'Sucesso!', body: resultSave.message }, 'success')
  }

  const saveVistoria = async () => {
    const validate = validateVistoria(vistoria)
      if (Object.keys(validate).length !== 0) {
        setErrors(validate)

        const campos = Object.values(validate)
          .map((e) => e?.message)
          .filter(Boolean)

        showAlert(
          {
            title: 'Atenção!',
            body: `Corrija os campos obrigatórios:\n\n${campos.join('\n')}`
          },
          'fail'
        )

        return {
          success: false,
          message: 'Corrija os campos obrigatórios destacados na tela.',
          type: 'fail'
        }
      }
      const placa = String(vistoria?.placa || '').trim()
      if (precisaValidarPlaca() && (!placa || placa.length < 7)) {
        setErrors((old) => ({
          ...old,
          placa: { message: 'Placa inválida/incompleta' }
        }))

        return {
          success: false,
          message: 'Preencha corretamente a PLACA.',
          type: 'fail'
        }
      }

      // Se a API da placa falhar, deixa seguir normalmente e permite preenchimento manual de ano/cor
      if (placaErro) {
        console.warn('Consulta da placa falhou:', placaErro)
      }

    setErrors({})
    setLoadSave(true)

    await carregarVistoriaEmPdfBase64()

    const content = inputVistoriaRef.current
    if (content) {
      content.style.marginLeft = '0px'
      content.style.marginRight = '0px'
      content.style.marginTop = '0px'
    }

    if (editVistoria) {
      const { osID, activityId } = ordemServico

      if (!vistoria.ClienteCpfCnpj) vistoria.ClienteCpfCnpj = vistoria.clienteCpfCnpj

      if (vistoria.statusEntrada === 'Aceito') {
        vistoria.ChecklistTipo = 'Saida'
      }

      vistoria.NumeroOS = vistoria?.numeroOS || ordemServico?.os

      const responseUpdateVistoria = await vistoriaService.updateVistoria(activityId, osID, JSON.stringify(vistoria))

      setLoadSave(false)

      if (responseUpdateVistoria?.error) {
        showAlert({ title: 'Erro!', body: responseUpdateVistoria.message }, 'error')
        return { success: false, message: responseUpdateVistoria.message, type: 'error' }
      }

      showAlert({ title: 'Sucesso!', body: 'A vistoria foi atualizada com sucesso.' }, 'success')
      return { success: true, message: 'A vistoria foi atualizada com sucesso.', type: 'success' }
    }

    vistoria.na = ordemServico?.na
    vistoria.antena = ordemServico?.antena
    vistoria.id_agendamento = ordemServico?.activityId
    vistoria.id_ordem_servico = ordemServico?.osID
    vistoria.id_cliente = ordemServico?.clienteID
    vistoria.id_area_atendimento = ordemServico?.id_area_atendimento
    vistoria.ClienteNome = vistoria.clienteNome
    vistoria.ClienteCpfCnpj = vistoria.clienteCpfCnpj
    vistoria.ChecklistTipo = 'Entrada'
    vistoria.NumeroOS = vistoria?.numeroOS || ordemServico?.os

    const response = await vistoriaService.createVistoria(JSON.stringify(vistoria))

    setLoadSave(false)

    if (response?.error) {
      showAlert({ title: 'Erro!', body: response.message }, 'error')
      return { success: false, message: response.message, type: 'error' }
    }

    setEditVistoria(true)
    showAlert({ title: 'Sucesso!', body: 'A vistoria foi cadastrada com sucesso.' }, 'success')
    return { success: true, message: 'A vistoria foi cadastrada com sucesso', type: 'success' }
  }

  const carregarVistoriaEmPdfBase64 = async () => {
    try {
      const marginLeft = 50
      const marginRight = 50

      const options = {
        filename: `VistoriaDe${tipoVistoria}.pdf`,
        image: { type: 'jpeg', quality: 0.75 },
        html2canvas: { scale: 1, margin: { left: marginLeft, right: marginRight } },
        jsPDF: {
          unit: 'pt',
          format: 'a4',
          orientation: 'portrait',
          compress: true,
          autoPaging: true
        }
      }

      const content = inputVistoriaRef.current

      if (!content) return

      content.style.marginLeft = `${marginLeft}px`
      content.style.marginRight = `${marginRight}px`
      content.style.marginTop = `${marginRight}px`

      const base64 = await html2pdf().from(content).set(options).toPdf().output('datauristring')
      vistoria.vistoriaPdfBase64 = base64
    } catch (error) {
      console.error('Erro:', error)
    }
  }

  const handleCloseEmailModal = async () => {
    setOpenEmailModal(false)
    await getVistoria()
  }

  const handleEmailSent = () => {
    setAlertEmailEnviado(true)
    setMensagemAlertaEmail('E-mail enviado com sucesso.')
    showAlert({ title: 'Sucesso!', body: 'E-mail enviado com sucesso.' }, 'success')
  }

  const handleOpenEmailModal = () => {
    const validate = validateVistoria(vistoria)
    if (Object.keys(validate).length !== 0) {
      setErrors(validate)
      showAlert({ title: 'Atenção!', body: 'Preencha os campos obrigatórios!' }, 'fail')
      return
    }

    if (precisaValidarPlaca() && (!vistoria?.placa || !vistoria?.ano || !vistoria?.cor)) {
      showAlert({ title: 'Atenção!', body: 'Preencha a placa, ano e cor para enviar o e-mail.' }, 'fail')
      return
    }

    if (isCpfInvalid()) {
      setCpfError('CPF inválido')
      showAlert({ title: 'Atenção!', body: 'CPF do conferente inválido. Corrija o CPF para enviar o e-mail.' }, 'fail')
      return
    }

    setOpenEmailModal(true)
    setErrors({})
  }

  return (
    <div style={{ margin: 30 }}>
      <h3 className={classes.tituloStyle}>Vistoria de {tipoVistoria === 'saida' ? 'Saída' : 'Entrada'}</h3>

      <h4 className={classes.subtituloStyle}>
        <span
          onClick={() => (window.location.href = '/agenda')}
          className={classes.linkStyle}
          style={{ cursor: 'pointer' }}
        >
          Home
        </span>{' '}
        {'>'} Ordem de Serviço
      </h4>

      <EmailModal
        open={openEmailModal}
        handleClose={handleCloseEmailModal}
        vistoria={vistoria}
        ordemServico={ordemServico}
        saveVistoria={saveVistoria}
        onEmailSent={handleEmailSent}
      />

      <Grid className={classes.actions}>
        <Grid item xs={12} sm={12}>
          <Button fullWidth onClick={handleBack} style={{ color: '#209BDE' }} startIcon={<ArrowBackIos />}>
            Voltar
          </Button>
        </Grid>
      </Grid>

      <Paper className={classes.paper}>
        <CustomAlert open={abrirAlert} message={mensagemAlert} type={tipoAlert} onClose={() => setAbrirAlert(false)} />

        {loadVistoria ? (
          <Grid container alignItems="center" justifyContent="center">
            <CircularProgress color="#209BDE" style={{ color: '#209BDE' }} />
          </Grid>
        ) : (
          <>
            <div ref={inputVistoriaRef}>
              <div className={classes.title} style={{ marginTop: 0 }}>
                Vistoria de {tipoVistoria === 'saida' ? 'Saída' : 'Entrada'}
              </div>
              <Divider />

              <div className={classes.subtitle}>Informações sobre instalação</div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    id="txtEquipamento"
                    label={
                      <span>
                        Equipamento <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    error={!!errors.equipamento}
                    helperText={errors.equipamento?.message}
                    defaultValue={vistoria?.rastreador || ordemServico?.rastreador || ''}
                    fullWidth
                    placeholder="Equipamento"
                    onChange={(event) => handleInputChange('equipamento', event.target.value)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    variant="outlined"
                    disabled={isDisabledEntry}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    error={!!errors.serie}
                    placeholder="Número de Série/ID"
                    helperText={errors.serie?.message}
                    id="txtNumSerie"
                    label={
                      <span>
                        Número de Série/ID <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    defaultValue={vistoria?.serie || ordemServico?.num_serie_contrato || ''}
                    onChange={(event) => handleInputChange('serie', event.target.value)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    variant="outlined"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    id="txtNA"
                    placeholder="NA"
                    label={
                      <span>
                        NA <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    defaultValue={vistoria?.na || ordemServico?.na || ''}
                    disabled
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    id="txtOS"
                    placeholder="Número da OS"
                    label={
                      <span>
                        Número da OS <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    defaultValue={vistoria?.numeroOS || ordemServico?.os || ''}
                    disabled
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    id="txtAntena"
                    placeholder="Antena Sat"
                    label={
                      <span>
                        Antena Sat <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: true
                    }}
                    defaultValue={ordemServico?.antena || ''}
                    disabled
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    error={!!errors.instalador}
                    helperText={errors.instalador?.message}
                    id="txtInstalador"
                    placeholder="Instalador e Auxiliar"
                    label={
                      <span>
                        Instalador e Auxiliar <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    defaultValue={vistoria?.instalador || ''}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={(event) => handleInputChange('instalador', event.target.value)}
                    variant="outlined"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>
              </Grid>

              <div className={classes.subtitle}>
                Tipo de serviço <span style={{ color: 'red' }}>*</span>
              </div>
              {!!errors.tipo_servico && (
                <span className={classes.errorText} style={{ marginTop: 20 }}>
                  {errors.tipo_servico.message}
                </span>
              )}

              <RadioGroup
                row
                id="rdpgTipoVeiculo"
                value={vistoria?.tipo_servico || ordemServico?.tipoServico || ''}
                onChange={(event) => handleInputChange('tipo_servico', event.target.value)}
                style={{ marginTop: errors.tipo_servico ? 2 : 20 }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControlLabel
                      value="IR"
                      control={<Radio color="primary" />}
                      label="Instalação/Reinstalação"
                      disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControlLabel
                      value="RM"
                      control={<Radio color="primary" />}
                      label="Revisão/Manutenção"
                      disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2}>
                    <FormControlLabel
                      value="RT"
                      control={<Radio color="primary" />}
                      label="Retirada"
                      disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2}>
                    <FormControlLabel
                      value="UP"
                      control={<Radio color="primary" />}
                      label="Upgrade"
                      disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>

              <div className={classes.subtitle}>Dados do cliente e veículo</div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    id="txtCliente"
                    label={
                      <span>
                        Cliente <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    value={ordemServico?.cliente || ''}
                    disabled
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" fullWidth error={!!errors.local_servico}>
                    <InputLabel id="label_local">
                      Local do serviço <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <Select
                      labelId="label_local"
                      label={
                        <span>
                          Local do Serviço <span style={{ color: 'red' }}>*</span>
                        </span>
                      }
                      disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                      id="select_local"
                      value={
                        locais.includes(vistoria?.local_servico?.trim() || ordemServico?.localAtendimento?.trim())
                          ? vistoria?.local_servico || ordemServico?.localAtendimento
                          : ''
                      }
                      onChange={(event) => handleInputChange('local_servico', event.target.value)}
                    >
                      <MenuItem value="" disabled>
                        Selecione um local
                      </MenuItem>
                      {locais.map((local) => (
                        <MenuItem key={local} value={local}>
                          {local}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.local_servico?.message}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    error={precisaValidarPlaca() && (!!errors.placa || !!placaErro)}
                    helperText={placaHelper}
                    id="txtPlaca"
                    label={
                      <span>
                        Placa {precisaValidarPlaca() && <span style={{ color: 'red' }}>*</span>}
                      </span>
                    }
                    value={vistoria?.placa || ''}
                    onChange={handlePlacaChange}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {placaLoading ? (
                            <CircularProgress size={18} style={{ color: '#209BDE' }} />
                          ) : (
                            <IconButton
                              aria-label="Pesquisar placa"
                              onClick={handlePlacaSearchClick}
                              disabled={
                                shouldDisableAutoFetch ||
                                disabledEditEntry ||
                                (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false) ||
                                String(vistoria?.placa || '').length < 7
                              }
                              size="small"
                            >
                              <Search style={{ color: '#209BDE' }} />
                            </IconButton>
                          )}
                        </InputAdornment>
                      )
                    }}
                  />

                  {autoItemUI.visible && precisaValidarPlaca() && (
                    <Box mt={1}>
                      <Alert severity={autoItemUI.severity}>{autoItemUI.message}</Alert>
                    </Box>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    error={precisaValidarPlaca() && !!errors.ano}
                    helperText={
                      precisaValidarPlaca()
                        ? errors.ano?.message ||
                          (permiteEdicaoManualPlaca
                            ? 'Preencha manualmente'
                            : 'Preenchido automaticamente pela placa')
                        : 'obrigatório para instalação'
                    }
                    placeholder="Ano"
                    id="txtAno"
                    label={
                      <span>
                        Ano {precisaValidarPlaca() && <span style={{ color: 'red' }}>*</span>}
                      </span>
                    }
                    type="number"
                    value={vistoria?.ano || ''}
                    onChange={(event) => handleInputChange('ano', event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    disabled={!permiteEdicaoManualPlaca}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    error={precisaValidarPlaca() && !!errors.cor}
                    helperText={
                      precisaValidarPlaca()
                        ? errors.cor?.message ||
                          (permiteEdicaoManualPlaca
                            ? 'Preencha manualmente'
                            : 'Preenchido automaticamente pela placa')
                        : 'obrigatório para instalação'
                    }
                    id="txtCor"
                    label={
                      <span>
                        Cor {precisaValidarPlaca() && <span style={{ color: 'red' }}>*</span>}
                      </span>
                    }
                    value={vistoria?.cor || ''}
                    onChange={(event) => handleInputChange('cor', event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    disabled={!permiteEdicaoManualPlaca}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} style={{ marginTop: 20 }}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="chkMecanico"
                        name="chkMecanico"
                        checked={parseBool(vistoria?.mecanico)}
                        value={vistoria?.mecanico}
                        onChange={(event) => handleInputChange('mecanico', !parseBool(event.target.value))}
                      />
                    }
                    label="Mecânico"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="chkInjecao"
                        name="chkInjecao"
                        checked={parseBool(vistoria?.injecao_eletronica)}
                        value={vistoria?.injecao_eletronica}
                        onChange={(event) => handleInputChange('injecao_eletronica', !parseBool(event.target.value))}
                      />
                    }
                    label="Injeção Eletrônica"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="chkDoze"
                        name="chkDoze"
                        checked={parseBool(vistoria?.doze_v)}
                        value={vistoria?.doze_v}
                        onChange={(event) => handleInputChange('doze_v', !parseBool(event.target.value))}
                      />
                    }
                    label="12V"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="chk24V"
                        name="chk24V"
                        checked={parseBool(vistoria?.vinte_quatro_v)}
                        value={vistoria?.vinte_quatro_v}
                        onChange={(event) => handleInputChange('vinte_quatro_v', !parseBool(event.target.value))}
                      />
                    }
                    label="24V"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>
              </Grid>

              <div className={classes.subtitle}>
                Tipo do veículo <span style={{ color: 'red' }}>*</span>
              </div>
              {!!errors.tipo_veiculo && <span className={classes.errorText}>{errors.tipo_veiculo.message}</span>}

              <RadioGroup
                row
                id="rdpgTPVeiculo"
                value={vistoria?.tipo_veiculo || ''}
                onChange={(event) => handleInputChange('tipo_veiculo', event.target.value)}
              >
                <Grid container>
                  {[
                    { v: 'CM', l: 'Cavalo Mec.' },
                    { v: 'TR', l: 'Truck' },
                    { v: 'TC', l: 'Toco' },
                    { v: 'VN', l: 'Van' },
                    { v: 'PS', l: 'Passeio' },
                    { v: 'MT', l: 'Moto' },
                    { v: 'CT', l: 'Caminhonete' },
                    { v: 'ON', l: 'Ônibus' },
                    { v: 'CR', l: 'Carreta' },
                    { v: 'LA', l: 'Linha amarela' }
                  ].map((x) => (
                    <Grid key={x.v} item xs={12} sm={3}>
                      <FormControlLabel
                        value={x.v}
                        control={<Radio color="primary" />}
                        label={x.l}
                        disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </RadioGroup>

              {vistoria?.tipo_veiculo === 'CR' && (
                <>
                  <div className={classes.subtitle}>
                    Dados da carreta <span style={{ color: 'red' }}>*</span>
                  </div>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <strong>Tipo da carreta: </strong>
                      <RadioGroup
                        row
                        id="rdpgTPCarreta"
                        value={vistoria?.tipo_carreta || ''}
                        onChange={(event) => handleInputChange('tipo_carreta', event.target.value)}
                      >
                        <Grid container>
                          {[
                            { v: 'CS', l: 'Carga Seca' },
                            { v: 'BA', l: 'Baú Alumínio' },
                            { v: 'BR', l: 'Baú Refrig.' },
                            { v: 'BG', l: 'BUG' },
                            { v: 'TR', l: 'Treminhão' },
                            { v: 'SD', l: 'Sider' },
                            { v: 'PL', l: 'Plataforma' }
                          ].map((x) => (
                            <Grid key={x.v} item xs={12} sm={3}>
                              <FormControlLabel
                                value={x.v}
                                control={<Radio color="primary" />}
                                label={x.l}
                                disabled={
                                  disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)
                                }
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </RadioGroup>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        id="txtPlacaCarreta"
                        label="Placa da Carreta"
                        value={vistoria?.placa_carreta}
                        onChange={(event) => handleInputChange('placa_carreta', event.target.value)}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <div className="html2pdf__page-break"></div>
              <div className={classes.title}>Vistoria do veículo</div>
              <Divider />

              <AvlPreliminarVistoria
                vistoria={vistoria}
                handleInputChange={handleInputChange}
                classes={classes}
                errors={errors}
                disabledEdit={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
              />

              <AvlLatariaVistoria
                vistoria={vistoria}
                handleInputChange={handleInputChange}
                parseBool={parseBool}
                classes={classes}
                disabledEdit={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
              />

              <VistoriaItems
                vistoria={vistoria}
                handleInputChange={handleInputChange}
                classes={classes}
                errors={errors}
                disabledEditEntry={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                disabledEditExit={disabledEditExit || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
              />

              <div className="html2pdf__page-break"></div>

              <ListaProdutosServicos
                na={ordemServico?.na}
                itensOS={itensOSLocal}
                vistoria={vistoria}
                handleInputChange={handleInputChange}
                classes={classes}
                errors={errors}
                disabledEditEntry={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                disabledEditExit={disabledEditExit || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
              />

              <div className="html2pdf__page-break"></div>
              <div className={classes.subtitle}>Dados do Cliente - Aprovação</div>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="NomeCliente"
                    label={
                      <span>
                        Nome do conferente <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    placeholder="Nome do conferente"
                    error={errors.clienteNome}
                    helperText={errors.clienteNome?.message}
                    value={vistoria?.clienteNome}
                    onChange={(event) => handleInputChange('clienteNome', event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    disabled={disabledEditEntry || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="documentoCliente"
                    label={
                      <span>
                        CPF do conferente <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    placeholder="CPF do conferente"
                    value={vistoria?.clienteCpfCnpj || ''}
                    onChange={cpfChange}
                    onBlur={handleCpfBlur}
                    error={!!cpfError}
                    helperText={cpfError}
                    onKeyPress={(e) => (e.key.match(/^[0-9]+$/) ? null : e.preventDefault())}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} style={{ marginTop: 20 }}>
                <Grid item xs={12}>
                  <TextField
                    id="txtObs"
                    fullWidth
                    label="Observações"
                    placeholder="Observações"
                    value={vistoria?.observacao || ordemServico?.obsCliente}
                    onChange={(event) => handleInputChange('observacao', event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    disabled={disabledEditExit || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                  />
                </Grid>

                {vistoria?.entrada && (
                  <Grid item xs={12}>
                    <TextField
                      id="txtObsResumo"
                      fullWidth
                      label="Resumo do Serviço"
                      value={vistoria?.resumo_servico}
                      style={{ width: '100%' }}
                      onChange={(event) => handleInputChange('resumo_servico', event.target.value)}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      disabled={disabledEditExit || (statusVistoria(vistoria, tipoVistoria) === 'Aceito' ? true : false)}
                    />
                  </Grid>
                )}
              </Grid>
            </div>

            <Grid container spacing={2} alignItems="center" justifyContent="flex-end" style={{ marginTop: '30px' }}>
              <Grid item xs={12} sm={3} md={2}>
                <BlueButton
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleOpenEmailModal}
                  startIcon={<Mail />}
                  disabled={
                    loadSave ||
                    (vistoria ? statusVistoria(vistoria, tipoVistoria) === 'Aceito' : false)
                  }
                  style={{ height: 55 }}
                >
                  <span style={{ fontSize: '0.7rem' }}>E-mail</span>
                </BlueButton>
              </Grid>

              <Grid item xs={12} sm={3} md={2}>
                {loadSave ? (
                  <Grid container alignItems="center" justifyContent="center">
                    <CircularProgress size={25} style={{ color: '#209BDE' }} />
                  </Grid>
                ) : (
                  <BlueButton
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleSaveVistoria}
                    startIcon={<Save />}
                    disabled={loadSave}
                    style={{ height: 55 }}
                  >
                    <span style={{ fontSize: '0.7rem' }}>Salvar</span>
                  </BlueButton>
                )}
              </Grid>
            </Grid>

            <Box style={{ marginTop: 20 }}>
              {alertEmailEnviado && <Alert severity="success">{mensagemAlertaEmail}</Alert>}
              {statusVistoria(vistoria, tipoVistoria) != 'Aceito' && (
                <Alert severity="info">
                  OBS: Após envio do e-mail, o cliente tem 15 minutos para aprovar a vistoria. Passado esse tempo, a vistoria será aceita automaticamente.
                </Alert>
              )}
            </Box>
          </>
        )}
      </Paper>
    </div>
  )
}
